/**
 * StatsCustomDragLayer — floating preview that follows the cursor while
 * a player is being dragged.
 *
 * Mirrors the original CustomDragLayer in EstadisticasNew.js but uses the
 * v2 theme tokens.
 */

import React from 'react';
import { useDragLayer } from 'react-dnd';
import { Box, Avatar, Typography } from '@mui/material';
import { useStatsTheme, withAlpha } from '../../theme/statsTheme';
import { ITEM_TYPE_PLAYER, PLAYER_SOURCES } from './DndStatsProvider';

export default function StatsCustomDragLayer() {
  const theme = useStatsTheme();

  const { isDragging, item, currentOffset, itemType } = useDragLayer((monitor) => ({
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    itemType: monitor.getItemType(),
  }));

  if (!isDragging || !currentOffset || !item || itemType !== ITEM_TYPE_PLAYER) {
    return null;
  }

  const player = item.player || {};
  const source = item.source || PLAYER_SOURCES.BENCH;
  const accent = source === PLAYER_SOURCES.FLOOR ? theme.actionColors.warning : theme.accent;

  return (
    <Box
      sx={{
        position: 'fixed',
        pointerEvents: 'none',
        left: currentOffset.x,
        top: currentOffset.y,
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Avatar
        src={player.avatarUrl}
        sx={{
          width: 80,
          height: 80,
          border: `3px solid ${accent}`,
          boxShadow: `0 12px 32px ${withAlpha(accent, 0.6)}, 0 0 0 6px ${withAlpha(accent, 0.18)}`,
          backgroundColor: theme.surfaces.floating,
          fontSize: 28,
          fontWeight: 700,
          color: theme.text.primary,
        }}
      >
        {player.nom?.charAt(0).toUpperCase() || '?'}
      </Avatar>
      <Typography
        sx={{
          fontFamily: theme.typography.fontFamily,
          fontSize: 11,
          fontWeight: 700,
          color: theme.text.primary,
          backgroundColor: withAlpha('#000000', 0.7),
          px: 1,
          py: 0.3,
          borderRadius: theme.radius.sm,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          maxWidth: 120,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {player.nom || ''}
      </Typography>
    </Box>
  );
}
